import { usePassThrough } from 'primevue/passthrough';
import { selectField } from '../shared/select-field';

export const multiselect = usePassThrough(selectField, {
  root: ({ props, state }: Record<string, any>) => ({
    class: [
      // Display and Position
      'inline-flex',
      'relative',
      // Shape
      'rounded-lg',
      'w-80 max-w-full',
      // Color and Background
      'border border-solid border-grey-300',
      {
        'bg-white': !props.disabled && !props.invalid,
        'bg-grey-50': props.disabled,
        'bg-red-100/50': props.invalid,
      },
      // Invalid State
      { 'border-red-500': props.invalid },
      // Transitions
      'transition-all',
      'duration-200',
      // States
      { 'hover:border-surface-400': !props.invalid },
      {
        'outline-none outline-offset-0 z-10 ring-1 ring-primary-500': state.focused,
      },
      // Misc
      'cursor-pointer',
      'select-none',
      {
        'bg-surface-200 select-none pointer-events-none cursor-default': props.disabled,
      },
    ],
    'data-testid': 'VSelect--multiple',
  }),
  dropdown: ({ props }: Record<string, any>) => ({
    class: [
      { hidden: props.disabled },
      'flex items-center justify-center',
      'shrink-0',
      'bg-transparent',
      'text-surface-500',
      'w-12',
      'rounded-r-md',
    ],
  }),
  loadingIcon: {
    'data-testid': 'v-select-loader',
  },
  labelcontainer: {
    class: ['grow', 'overflow-x-hidden'],
  },
  label: ({ props }: Record<string, any>) => ({
    class: [
      'text-base leading-[normal]',
      // Size
      {
        'text-xs': props.size === 'small',
        'text-xl': props.size === 'large',
      },
      // Spacing
      {
        'em:py-2 em:px-3 pr-0':
          props.display === 'comma' || (props.display === 'chip' && !!props?.modelValue?.length),
        'py-1 px-1': props.display === 'chip' && !!props?.modelValue?.length,
      },
      // Color
      {
        'text-grey-400': !props?.modelValue?.length,
      },
      'placeholder:text-surface-400',
      // Transitions
      'transition duration-200',
      // Misc
      'overflow-hidden whitespace-nowrap cursor-pointer overflow-ellipsis',
    ],
  }),
  overlay: {
    class: [
      'box-content',
      'bg-white',
      'border border-solid border-grey-200',
      'rounded-lg',
      'shadow',
      'text-[16px] font-sans font-normal',
    ],
  },
  listContainer: {
    class: ['max-h-[200px]', 'overflow-auto'],
  },
  list: {
    class: 'py-2 list-none m-0',
  },
  option: ({ context }: Record<string, any>) => ({
    class: [
      // Font
      'leading-none',
      { 'font-normal': !context.selected, 'font-bold': context.selected },
      // Position
      'flex items-center',
      'relative',
      // Shape
      'border-0',
      'rounded-none',
      // Spacing
      'm-0',
      'py-2 px-4 gap-2',
      // Color
      {
        'bg-primary-300': context.focused && !context.selected,
      },
      {
        'bg-primary-300': context.focused && context.selected,
      },
      { 'bg-transparent': !context.focused && context.selected },
      // States
      'hover:bg-primary-300',
      // Misc
      'cursor-pointer',
      'overflow-hidden',
      'whitespace-nowrap',
      'group/option',
    ],
  }),
  pcOptionCheckbox: {
    box: {
      class: ['hidden'],
    },
    root: {
      class: ['hidden'],
    },
  },
  optionLabel: {
    class: ['truncate'],
  },
});
